import { render } from "./RecentAlertList.vue?vue&type=template&id=5681ea2c"
import script from "./RecentAlertList.vue?vue&type=script&lang=js"
export * from "./RecentAlertList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__